import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconTune = /*@__PURE__*/ proxyCustomElement(class WppIconTune extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-tune", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13.5417 3.875C13.0354 3.875 12.625 4.28541 12.625 4.79167C12.625 5.29793 13.0354 5.70833 13.5417 5.70833C14.0479 5.70833 14.4583 5.29793 14.4583 4.79167C14.4583 4.28541 14.0479 3.875 13.5417 3.875ZM11.2437 4.04163C11.5592 3.07411 12.4688 2.375 13.5417 2.375C14.6145 2.375 15.5241 3.07411 15.8397 4.04163H17.7083C18.1225 4.04163 18.4583 4.37741 18.4583 4.79163C18.4583 5.20584 18.1225 5.54163 17.7083 5.54163H15.8397C15.5242 6.50918 14.6146 7.20833 13.5417 7.20833C12.4688 7.20833 11.5592 6.50918 11.2436 5.54163H2.29163C1.87741 5.54163 1.54163 5.20584 1.54163 4.79163C1.54163 4.37741 1.87741 4.04163 2.29163 4.04163H11.2437ZM12.7083 14.2916C12.202 14.2916 11.7916 14.702 11.7916 15.2083C11.7916 15.7146 12.202 16.125 12.7083 16.125C13.2146 16.125 13.625 15.7146 13.625 15.2083C13.625 14.702 13.2146 14.2916 12.7083 14.2916ZM10.4102 14.4584C10.7258 13.4908 11.6354 12.7916 12.7083 12.7916C13.7812 12.7916 14.6908 13.4908 15.0063 14.4584H17.7083C18.1225 14.4584 18.4583 14.7942 18.4583 15.2084C18.4583 15.6226 18.1225 15.9584 17.7083 15.9584H15.0063C14.6907 16.9259 13.7811 17.625 12.7083 17.625C11.6354 17.625 10.7259 16.9259 10.4103 15.9584H2.29163C1.87741 15.9584 1.54163 15.6226 1.54163 15.2084C1.54163 14.7942 1.87741 14.4584 2.29163 14.4584H10.4102ZM5.54163 10C5.54163 9.49378 5.95203 9.08337 6.45829 9.08337C6.96455 9.08337 7.37496 9.49378 7.37496 10C7.37496 10.5063 6.96455 10.9167 6.45829 10.9167C5.95203 10.9167 5.54163 10.5063 5.54163 10ZM6.45829 7.58337C5.38543 7.58337 4.47585 8.28249 4.16028 9.25H2.29163C1.87741 9.25 1.54163 9.58579 1.54163 10C1.54163 10.4142 1.87741 10.75 2.29163 10.75H4.16025C4.4758 11.7176 5.3854 12.4167 6.45829 12.4167C7.53119 12.4167 8.44078 11.7176 8.75633 10.75H17.7083C18.1225 10.75 18.4583 10.4142 18.4583 10C18.4583 9.58579 18.1225 9.25 17.7083 9.25H8.75631C8.44073 8.28249 7.53116 7.58337 6.45829 7.58337Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-tune-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-tune", "wpp-icon-tune-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-tune-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-tune-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconTune);
      }
      break;
  } });
}

export { WppIconTune as W, defineCustomElement as d };
